<template>
  <ConfirmDialog></ConfirmDialog>
  <Toast />
  <ComprasCreate
    :mostrar="NuevaCompra"
    @closeModal="closeModal"
    @actualizarListadoOC="cargarComprasFiltros"
    
  ></ComprasCreate>
  <!-- @actualizarListadoOC="cargarOrdenesCompras" -->
  <ul class="list-none p-0 m-0 flex align-items-center font-medium mb-3">
    <li>
      <a class="text-500 no-underline line-height-3 cursor-pointer">Compras</a>
    </li>
    <li class="px-2">
      <i class="pi pi-angle-right text-500 line-height-3"></i>
    </li>
    <li>
      <span class="text-900 line-height-3 active">Listado de Compras </span>
    </li>
  </ul>
  <div class="surface-section px-4 py-5 md:px-12 lg:px-12">
    <div
      class="flex align-items-start flex-column lg:justify-content-between lg:flex-row"
    >
      <div class="font-medium text-3xl text-900">
        <strong>Administrar &Oacute;rdenes de Compras </strong>
        <Badge size="xlarge" severity="success"> {{ totalRecords }}</Badge>
      </div>

      <div class="mt-3 lg:mt-0">
        <Button
          label="NUEVA SOLICITUD OC"
          v-tooltip.top="'Solicitar Nueva Orden de Compra'"
          v-if="'Compra Crear' in auth.user.permissions"
          class="p-button-outlined mr-2 p-button-primary p-button-raised p-button-lg"
          icon="pi pi-plus"
          @click="activarModal"
        ></Button>
        <Button
          label="ORDEN DE COMPRA"
          v-tooltip.top="'Registrar Orden de Compra'"
          v-if="'Compra Crear' in auth.user.permissions"
          class="p-button-outlined mr-2 p-button-success p-button-raised p-button-lg"
          icon="pi pi-plus"
          @click="nuevaCompra"
        ></Button>
      </div>
    </div>
    <div class="col-12">
      <div class="card p-fondo">
        <div class="p-fluid formgrid grid">
          <div class="field col-12 md:col-2">
            <label for="nro_recibo"><strong>RECIBO/FACTURA: </strong></label>
            <InputText
              v-model="nro_recibo"
              placeholder="Nro Recibo"
              :class="'text-right'"
              @keyup.enter="BuscarFiltro"
            />
          </div>
          <div class="field col-12 md:col-2">
            <label for="proveedor"><strong>PROVEEDOR: </strong></label>
            <Dropdown
              v-model="proveedorSelected"
              :options="proveedores"
              optionLabel="nombre_completo"
              placeholder="Seleccionar..."
              optionValue="id"
              :filter="true"
            />
          </div>
          <div class="field col-12 md:col-2">
            <label for="fecha_inicio"><strong>FECHA INICIO: </strong></label>
            <Calendar
              v-model="fecha_inicio"
              :class="'text-right'"
              :showIcon="true"
              dateFormat="dd/mm/yy"
            />
          </div>
          <div class="field col-12 md:col-2">
            <label for="fecha_fin"><strong>FECHA FIN: </strong></label>
            <Calendar
              v-model="fecha_fin"
              :class="'text-right'"
              :showIcon="true"
              dateFormat="dd/mm/yy"
            />
          </div>
          <div class="field col-12 md:col-2">
            <label for="estado"><strong>ESTADO: </strong></label>
            <Dropdown
              v-model="estadoSelected"
              :options="estados"
              optionLabel="nombre"
              optionValue="id"
              placeholder="Estados..."
            />
          </div>
          <div class="field col-12 md:col-2">
            <label for="acciones"><strong>ACCIONES: </strong></label>
            <Button
              label="BUSCAR"
              icon="pi pi-search"
              class="p-button-primary mr-2"
              v-tooltip.top="'Buscar'"
              @click="BuscarFiltro"
              :loading="loading"
            />
          </div>
        </div>
      </div>
      <div class="mt-4">
        <DataTable
          ref="dt_oc_list"
          dataKey="id"
          class="p-datatable-sm"
          responsiveLayout="scroll"
          stripedRows
          selectionMode="single click"
          showGridlines
          :value="ordenes_compras"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          :rowsPerPageOptions="[50, 100, 200, 500, 1000]"
          currentPageReportTemplate="Mostrando {first} de {last} de {totalRecords} Orden de Compras"
          :loading="loading"
          :paginator="true"
          :rows="50"
          :rowHover="true"
        >
          <!-- :lazy="true"
          filterDisplay="menu"
          :totalRecords="totalRecords"
          v-model:filters="buscar"
          @page="onPage($event)"
          @sort="onSort($event)"
          @filter="onFilter($event)"
          tableStyle="min-width: 75rem" -->
          <template #loading>
            <div class="flex align-items-center justify-content-center">
              <ProgressSpinner />
            </div>
          </template>
          <template #empty>
            <span
              class="flex align-items-center justify-content-center p-invalid"
              >No existen Registros!</span
            ></template
          >
          <!-- <Column header="#">
            <template #body="slotProps">
              {{ 1 + slotProps.index }}
            </template>
          </Column> -->
          <Column field="id" header="ID"></Column>
          <Column field="nro_recibo" header="REC/FAC" :class="'text-right'">
            <template #body="slotProps">
              <span v-if="slotProps.data.nro_recibo">
                {{ slotProps.data.nro_recibo }}
              </span>
              <span v-else>-</span>
            </template>
          </Column>
          <!-- <Column
            field="id"
            header="CÓDIGO"
            filterMatchMode="startsWith"
            :showFilterMatchModes="false"
            :class="'text-right'"
          >
            <template #filter="{ filterModel, filterCallback }">
              <InputText
                type="text"
                v-model="filterModel.value"
                @keydown.enter="filterCallback()"
                class="p-column-filter"
                placeholder="CÓD..."
              />
            </template>
          </Column> -->
          <Column field="nombre_user" header="SOLICITADO POR"></Column>
          <Column field="nombre_completo" header="PROVEEDOR" style="font-weight: bold"></Column>
          <!-- <Column
            field="proveedor.nombre_completo"
            header="PROVEEDOR"
            style="font-weight: bold"
            :showFilterMatchModes="false"
          >
            {{ data.proveedor.nombre_completo }}
            <template #filter="{ filterModel, filterCallback }">
              <InputText
                type="text"
                v-model="filterModel.value"
                @keydown.enter="filterCallback()"
                class="p-column-filter"
                placeholder="PROVEEDOR..."
              />
            </template>
          </Column> -->
          <Column field="nombre_fabrica" header="MARCA"></Column>
          <Column field="fecha_registro" header="F.SOLICITUD"></Column>
          <Column field="estado" header="ESTADO">
            <template #body="{ data }">
              <span :class="'product-badge ' + claseEstado[data.estado]">
                {{ estados.find((e) => e.id == data.estado).nombre }}
              </span>
            </template>
          </Column>
          <Column header="ACCIONES">
            <template #body="slotProps">
              <Button
                icon="pi pi-ellipsis-v"
                v-tooltip.top="'Ver Acciones'"
                class="p-button-icon-only p-button-raised"
                @click="$refs['menu' + slotProps.data.id].toggle($event)"
              ></Button>
              <Menu
                :ref="'menu' + slotProps.data.id"
                :popup="true"
                :model="acciones(slotProps.data)"
              ></Menu>
            </template>
          </Column>
        </DataTable>
        <PagoProveedor
          :show="pagoProveedorDialog"
          :pago_proveedor="{ ...pago_proveedor }"
          @closeModal="cerrarModalPagoProveedor"
          @actualizarListado="cargarComprasFiltros"
        />
        <!-- @actualizarListado="cargarOrdenesCompras" -->
      </div>
    </div>
  </div>
</template>

<script>
import { FilterMatchMode } from "primevue/api";
import ComprasCreate from "@/module/compras/ComprasCreate.vue";
import OrdenCompraService from "@/service/OrdenCompraService";
import { useAuth } from "@/stores";
import PagoProveedor from "@/module/proveedores/PagoProveedor.vue";
import ProveedorService from "@/service/ProveedorService";

export default {
  name: "Compras",
  components: {
    ComprasCreate,
    PagoProveedor,
  },
  data() {
    return {
      NuevaCompra: false,
      ordenes_compras: [],
      loading: false,
      buscar: null,
      claseEstado: [
        "status-outofstock",
        "status-lowstock",
        "customer-badge status-new",
        "status-instock",
      ],
      pagoProveedorDialog: false,
      pago_proveedor: {},
      totalRecords: 0,
      /* lazyParams: {}, */
      estados: [
        { nombre: "TODOS", id: 4 },
        { nombre: "ANULADO", id: 0 },
        { nombre: "PENDIENTE - POR RECIBIR", id: 1 },
        { nombre: "RECIBIDO - POR PAGAR", id: 2 },
        { nombre: "RECIBIDO - PAGADO", id: 3 },
      ],
      estadoSelected: 4,
      nro_recibo: null,
      fecha_inicio: null,
      fecha_fin: null,
      proveedores: [{ id: 0, nombre_completo: "TODOS" }],
      proveedorSelected: 0,
    };
  },
  ordenesCompras: null,
  auth: useAuth(),
  proveedorService: null,

  created() {
    this.auth = useAuth();
    this.ordenesCompras = new OrdenCompraService();
    this.initBuscar();
    this.proveedorService = new ProveedorService();
  },
  mounted() {
    /* this.loading = true;
    this.lazyParams = {
      first: 0,
      rows: this.$refs.dt_oc_list.rows,
      sortField: null,
      sortOrder: null,
      filters: this.buscar,
    };
    this.cargarOrdenesCompras(); */
    this.cargarComprasFiltros();
    /* this.cargarProveedores(); */
  },
  methods: {
    BuscarFiltro() {
      this.ordenes_compras = [];
      this.loading = true;
      this.cargarComprasFiltros();
    },
    cargarComprasFiltros() {
      this.cargarProveedores();
      this.loading = true;
      let datos = {
        nro_recibo: this.nro_recibo,
        fecha_inicio: this.fecha_inicio,
        fecha_fin: this.fecha_fin,
        proveedor_id: this.proveedorSelected,
        estado: this.estadoSelected,
      };
      this.ordenesCompras
        .getOrdenesComprasFiltros(datos)
        .then((data) => {
          this.ordenes_compras = data.ordenes_compra;
          this.totalRecords = data.ordenes_compra.length;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },
    cargarProveedores() {
      this.proveedorService
        .getProveedores()
        .then((data) => {
          this.proveedores = data.proveedores;
          this.proveedores.unshift({ id: 0, nombre_completo: "TODOS" });
        })
        .catch((error) => console.log(error));
    },
    /* onPage(event) {
      this.lazyParams = event;
      this.cargarOrdenesCompras();
    },
    onSort(event) {
      this.lazyParams = event;
      this.cargarOrdenesCompras();
    },
    onFilter() {
      this.lazyParams.filters = this.buscar;
      this.cargarOrdenesCompras();
    }, */
    nuevaCompra() {
      this.$router.push({
        name: "oc_recepcion",
        params: { id: "nueva_compra" },
      });
    },
    acciones(datos) {
      return [
        {
          label: "Ver OC",
          icon: "pi pi-fw pi-eye",
          disabled:
            "Compra Ver Detalle" in this.auth.user.permissions ? false : true,
          to: `/orden_compra/${datos.id}/detalle`,
        },
        {
          label: "Recibir OC",
          disabled: datos.estado != 1 ? true : false,
          visible:
            "Compra Recibir" in this.auth.user.permissions ? true : false,
          icon: "pi pi-fw pi-save",
          to: `/oc/${datos.id}/recibir`,
        },
        {
          label: "Descargar PDF",
          disabled:
            "Compra DescargarPDF" in this.auth.user.permissions ? false : true,
          icon: "pi pi-fw pi-file-pdf",
          command: () => {
            this.imprimirOC(datos.id);
          },
        },
        /* {
          label: "Recibo OC",
          disabled:
            datos.estado != 2
              ? true
              : false ||
                "Compra Ver DetalleRecepcion" in this.auth.user.permissions
              ? false
              : true,
          icon: "pi pi-fw pi-list",
          to: `/oc/${datos.id}/detalle_recepcion`,
        }, */
        {
          label: "Anular OC",
          disabled: datos.estado != 1 ? true : false,
          visible: "Compra Anular" in this.auth.user.permissions ? true : false,
          icon: "pi pi-fw pi-times",
          command: () => {
            this.anularOC(datos.id);
          },
        },
        {
          label: "Pagar OC",
          disabled: datos.estado != 2 ? true : false,
          icon: "pi pi-fw pi-money-bill",
          /* command: () => {
            if (datos.oc_recepcion) {
              this.NuevoPagoProveedor(datos.oc_recepcion);
            }
          }, */
          to: `/proveedorpagos`,
        },
      ];
    },
    NuevoPagoProveedor(datos) {
      this.pago_proveedor = { ...datos.pago_proveedor };
      this.pagoProveedorDialog = true;
      this.pago_proveedor.fecha_pago = new Date();
      this.pago_proveedor.monto = datos.saldo;
      this.pago_proveedor.observacion = "";
    },
    cerrarModalPagoProveedor() {
      this.pagoProveedorDialog = false;
    },
    anularOC(id) {
      this.$confirm.require({
        message: "¿Está seguro que desea anular la Orden de Compra?",
        header: "Confirmación",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Si, deseo Anular",
        accept: () => {
          this.ordenesCompras.anular(id).then((response) => {
            this.$toast.add({
              severity: "success",
              summary: "Éxito",
              detail: response.mensaje,
              life: 3000,
            });
            this.loading = true;
            /* this.cargarOrdenesCompras(); */
            this.cargarComprasFiltros();
          });
        },
        reject: () => {
          //callback to execute when user rejects the action
        },
        onHide: () => {
          //Callback to execute when dialog is hidden
        },
      });
    },
    imprimirOC(id) {
      this.ordenesCompras
        .imprimirOC(id)
        .then(() => {})
        .catch((error) => console.log(error));
    },
    recibirOC(data) {
      this.$router.push(`/oc/${data.id}/recibir`);
    },
    /* cargarOrdenesCompras() {
      this.loading = true;
      setTimeout(() => {
        this.ordenesCompras
          .getAllOrdenesCompra({ dt_params: JSON.stringify(this.lazyParams) })
          .then((data) => {
            this.totalRecords = data.ordenes_compra.total;
            this.ordenes_compras = data.ordenes_compra.data || [];
            this.loading = false;
          });
      }, Math.random() * 1000 + 250);
    }, */
    activarModal() {
      this.NuevaCompra = true;
    },
    closeModal() {
      this.NuevaCompra = false;
      this.orden_compra = {};
    },
    verDetalle(orden_compra) {
      this.$router.push(`/orden_compra/${orden_compra.id}/detalle`);
    },
    initBuscar() {
      this.buscar = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        id: { value: null, matchMode: FilterMatchMode.EQUALS },
        "proveedor.nombre_completo": {
          value: null,
          matchMode: FilterMatchMode.CONTAINS,
        },
      };
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/assets/demo/badges.scss";
.p-invalid {
  color: red;
}
.p-fondo {
  background-color: #7bffae;
}
</style>
